<template>
  <v-overlay :value="nowLoading" z-index="1000">
    <v-progress-circular indeterminate size="64" />
  </v-overlay>
</template>

<script>
export default {
  name: 'NowLoadingOverlayComponent',
  props: ['nowLoading'],
}
</script>
